import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { ColorEvent } from 'ngx-color';
import { fromEvent } from 'rxjs';
import { debounceTime, filter, switchMap } from 'rxjs/operators';
import { ResponseUSer } from 'src/app/_models';
import { AuthenticationService } from 'src/app/_services';
import { FontServiceService } from 'src/app/_services/font-service.service';



@Component({
  selector: 'app-appareance',
  templateUrl: './appareance.component.html',
  styleUrls: ['./appareance.component.css']
})
export class AppareanceComponent implements OnInit,AfterViewInit,OnDestroy  {
  fromSelect:FormGroup;
  mySubscription: any; 
  currentUser: ResponseUSer;

selected;
idx=0;
pairs= [
{​​​​​​​​ header:'Oswald', body:'EB Garamond'}​​​​​​​​,
{​​​​​​​​ header:'Oswald',  body:'Cardo'}​​​​​​​​,
{​​​​​​​​ header:'Open Sans', body:'Open Sans Condensed'}​​​​​​​​,
{​​​​​​​​ header:'Raleway', body:'Roboto Slab'}​​​​​​​​,
{​​​​​​​​ header:'Roboto', body:'Roboto Condensed'}​​​​​​​​,
{​​​​​​​​ header:'Playfair Display', body:'Source Sans Pro'}​​​​​​​​,
{​​​​​​​​ header:'Playfair Display', body:'Chivo'}​​​​​​​​,
{​​​​​​​​ header:'Alegreya', body:'Lato'}​​​​​​​​,
{​​​​​​​​ header:'Fjalla One', body:'Noto Sans'}​​​​​​​​,
{​​​​​​​​ header:'PT Sans', body:'PT Sans Narrow'}​​​​​​​​,
{​​​​​​​​ header:'Josefin Sans', body:'Amatic SC'}​​​​​​​​,
{​​​​​​​​ header:'Merriweather', body:'Montserrat'}​​​​​​​​,
{​​​​​​​​ header:'Quicksand', hstyle:'medium',  body:'Quickand', bstyle:'light'}​​​​​​​​,
{​​​​​​​​ header:'Archivo Black',  body:'Judson'}​​​​​​​​,
{​​​​​​​​ header:'Crimson Text',  body:'Work Sans'}​​​​​​​​,
{​​​​​​​​ header:'Abril Fatface', body:'Roboto', bstyle:'light'}​​​​​​​​,
{​​​​​​​​ header:'Archivo', hstyle:'medium', body:'Open Sans', bstyle:'light'}​​​​​​​​,
{​​​​​​​​ header:'Montserrat', body:'Work Sans'}​​​​​​​​,
{​​​​​​​​ header:'Montserrat', body:'Lora'}​​​​​​​​,
{​​​​​​​​ header:'Prata', body:'Lato'}​​​​​​​​,
  ];
coabove: any;
cobelow:any;
  


  constructor( private fontService: FontServiceService
    ,private router: Router,
    private authenticationService: AuthenticationService,private formbuilder:FormBuilder) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((events) => {
      this.authenticationService.currentUser.subscribe(x => this.currentUser = x);


    });
     this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log("ddddd")
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = true;
      }
    })
 
  }
  ngOnDestroy(): void {
    
    if (this.mySubscription) {
      
      this.mySubscription.unsubscribe();
     
    }
    var element = document.getElementById('SubMenu');
    element.style.display = 'none';
  
    localStorage.setItem('header', '0');

  }
  ngAfterViewInit(): void {
    const main =  <HTMLInputElement>document.getElementById('SubMenu');


    fromEvent(main, 'mouseenter')
    .pipe(   
      switchMap(event => {
        console.log('show');
        main.style.display = 'block';
        return fromEvent(main, 'mouseleave').pipe(debounceTime(500));
      })
      )
    .subscribe(val => {
     console.log('hide');
     main.style.display = 'none';
   });
   document.getElementById("toolbar").style.background=  this.coabove;
   document.getElementById("fondo").style.color=this.cobelow;
  }
 

  ngOnInit(): void { 
    this.fromSelect=this.formbuilder.group({
      selec:[""]
    })
    this.coabove= localStorage.getItem("coabove");
    this.cobelow= localStorage.getItem("cobelow");
    
    this.idx=Number(localStorage.getItem("estilofuente"));
    this.setPair();
  }
  

  handleChangePrimary($event: ColorEvent) {

    this.coabove=$event.color.hex;

        document.getElementById("toolbar").style.background=  this.coabove;
        
   
  }
  handleChangeFont($event: ColorEvent) {
    this.cobelow=$event.color.hex;
	document.getElementById("fondo").style.cssText="color:"+this.cobelow +"!important;";
    //document.getElementById("fondo").style.background=this.cobelow;
  }

  setPair() {
    this.selected = this.pairs[this.idx];
    this.fontService.loadFont(this.selected);
  }
  
  onClick(n:number) {
    this.idx
    if(this.idx + n < 0) {
      this.idx = this.pairs.length - 1;
    } else if(this.idx + n > this.pairs.length - 1) {
      this.idx = 0;
    } else {
      this.idx += n;
    }
    this.setPair();
  }
  onSaveCustomize(){
    this.selected = this.pairs[this.fromSelect.controls.selec.value]  ;
  
    this.fontService.loadFont(this.selected);
    localStorage.setItem("coabove",this.coabove);
    localStorage.setItem("cobelow",this.cobelow);
    localStorage.setItem("estilofuente",this.fromSelect.controls.selec.value );
    
   window.location.reload();
    
  }
  

}
